import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import {
    DxPivotGridModule,
    DxChartModule,
    DxButtonModule,
    DxLoadPanelModule,
    DxTextBoxModule,
    DxNumberBoxModule,
    DxTextAreaModule,
    DxPopoverModule,
    DxSelectBoxModule, 
    DxCheckBoxModule,
    DxDateBoxModule,
    DxNavBarModule,
    DxListModule,
    DxBoxModule,
    DxToolbarModule,
    DxDropDownButtonModule,
    DxPopupModule,
    DxContextMenuModule,
    DxButtonGroupModule,
    DxDataGridModule, 
    DxProgressBarModule,
    DxTabPanelModule,
    DxFormModule,
    DxScrollViewModule,
    DxSchedulerModule,
    DxDraggableModule,
    DxAccordionModule,
    DxDrawerModule,
    DxRadioGroupModule,
    DxSwitchModule,
    DxDropDownBoxModule,
    DxTreeViewModule,
    DxTagBoxModule,
    DxValidatorModule,
    DxFileUploaderModule,
    DxHtmlEditorModule,
    DxLoadIndicatorModule,
    DxValidationGroupModule,
    DxTooltipModule,
    DxFileManagerModule,
    DxColorBoxModule,
    DxTileViewModule, 
    DxGalleryModule,
    DxGanttModule,
    DxDiagramModule,
    DxSortableModule,
    DxMapModule,
    DxSliderModule
} from 'devextreme-angular';

@NgModule({
    declarations: [],
    exports: [
        DxDataGridModule,
        DxFormModule,
        DxButtonModule,
        DxLoadPanelModule,
        DxTextBoxModule,
        DxNumberBoxModule,
        DxTextAreaModule,
        DxSelectBoxModule, 
        DxCheckBoxModule,
        DxDateBoxModule,
        DxPopoverModule,
        DxNavBarModule,
        DxListModule,
        DxBoxModule,
        DxToolbarModule,
        DxDropDownButtonModule,
        DxPopupModule,
        DxContextMenuModule,
        DxButtonGroupModule,
        DxDataGridModule,
        DxTabPanelModule,
        DxProgressBarModule,
        DxFormModule,
        DxScrollViewModule,
        DxSchedulerModule,
        DxDraggableModule,
        DxAccordionModule,
        DxDrawerModule,
        DxRadioGroupModule,
        DxSwitchModule,
        DxDropDownBoxModule,
        DxTreeViewModule,
        DxTagBoxModule,
        DxValidatorModule,
        DxFileUploaderModule,
        DxHtmlEditorModule,
        DxPivotGridModule,
        DxChartModule,
        DxLoadIndicatorModule,
        DxValidationGroupModule,
        DxTooltipModule,
        DxFileManagerModule,
        DxColorBoxModule,
        DxTileViewModule,
        DxGalleryModule,
        DxGanttModule,
        DxDiagramModule,
        DxSortableModule,
        DxMapModule,
        DxSliderModule,
    ],
    imports: [
        DxPivotGridModule,
        DxChartModule,
        DxButtonModule,
        DxLoadPanelModule,
        DxTextBoxModule,
        DxNumberBoxModule,
        DxTextAreaModule,
        DxPopoverModule,
        DxSelectBoxModule,
        DxCheckBoxModule,
        DxDateBoxModule,
        DxNavBarModule,
        DxListModule,
        DxBoxModule,
        DxToolbarModule,
        DxPopupModule,
        DxContextMenuModule,
        DxButtonGroupModule,
        DxDataGridModule,
        DxProgressBarModule,
        DxTabPanelModule,
        DxFormModule,
        DxScrollViewModule,
        DxSchedulerModule,
        DxDraggableModule,
        DxAccordionModule,
        DxDrawerModule,
        DxRadioGroupModule,
        DxSwitchModule,
        DxDropDownBoxModule,
        DxTreeViewModule,
        DxTagBoxModule,
        DxValidatorModule,
        DxFileUploaderModule,
        DxHtmlEditorModule,
        DxLoadIndicatorModule,
        DxValidationGroupModule,
        DxTooltipModule,
        DxFileManagerModule,
        DxColorBoxModule,
        DxTileViewModule,
        DxGalleryModule,
        DxGanttModule,
        DxDiagramModule,
        DxSortableModule,
        DxMapModule,
        DxSliderModule
    ],
    providers: [],
    bootstrap: [],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class DevExtremeModule { }
